module.exports = __webpack_public_path__ + "static/media/sortingup-theme.052e54d8.svg";